import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=22fc38e3"
import script from "./Header.js?vue&type=script&lang=js&external"
export * from "./Header.js?vue&type=script&lang=js&external"
import style0 from "./Header.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports